export default {
  watch: {
    value(newVal, oldVal) {
      this.result = newVal;
      if (this.onlyRead) {
        this.result = this.onlyReadShowData || newVal;
      }
    },
    onlyReadShowData(newVal) {
      this.result = newVal;
    },
  },
};
